import { EVENTS } from '../../bus/events.const';
import { WIRES } from '../wires';
import { Wiring } from '../wiring.interfaces';

export const CONFIG_WIRING: Wiring = {
  [EVENTS.DynamicConfigChanged]: [
    WIRES.setDynamicConfig
  ],
  [EVENTS.StoreChanged]: [
    WIRES.setDynamicConfig,
    WIRES.clearFilters,
    WIRES.search,
    WIRES.getPopularSearches,
    WIRES.getTermSuggestions
  ]
};
